import { render, staticRenderFns } from "./productivity-dashboard.html?vue&type=template&id=819ab4b4&scoped=true&"
import script from "./productivity-dashboard.ts?vue&type=script&lang=js&"
export * from "./productivity-dashboard.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819ab4b4",
  null
  
)

export default component.exports